module.exports = __webpack_public_path__ + "img/arrow.4be6013a.png";